import { Box, CircularProgress, Grid, IconButton, Stack } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { formContainer } from "../../../container/form.container";
import NewCreateEventScheduleContainer from "../../../container/org-admin/newCreateEventSchedule.container";
import { toggleModelShow } from "../../../shared/CustomFunc";
import ControlForm from "../../../shared/form/ControlForm";
import { DeleteIcon } from "../../../shared/icon";
import VSNButton from "../../../shared/VSNButton";
import VSNConfirmBox from "../../../shared/VSNConfirmBox";
import VSNErrorMessage from "../../../shared/VSNErrorMessage";
import VSNLabel from "../../../shared/VSNLabel";
import VSNModel from "../../../shared/VSNModel";
import VSNTypography from "../../../shared/VSNTypography";
import { upperCase } from "../../../utils/javascript";
import EventEmailPreviewModal from "./EventEmailPreviewModal";
import { EventScheduleStyle } from "./EventScheduleStyle";

const EventDetails = () => {
  const {
    eventId,
    createEventScheduleAttribute,
    handleCreateEventSchedule,
    handleChange,
    formPath,
    dispatch,
    modelState,
    handleMobileChange,
    handleDateChange,
    handleTimeChange,
    handleSwitchChange,
    handleChangePhoto,
    DownloadUploadedCSVFile,
    handleViewRoster,
    removeUploadedFile,
    downloadTemplateFile,
    viewRosterList,
    loaders,
    showDialog,
    onEditCreateClick,
    onHandleCancle,
    isEditMode,
    setIsEditMode,
    handleCancleEditEvent,
    highlighted,
    onDragEnter,
    onDragLeave,
    eventScheduleInfo,
  } = NewCreateEventScheduleContainer();

  const classes = EventScheduleStyle();
  const { formData, formErrors } = formContainer({ formPath });
  const navigate = useNavigate();

  const formSectionAttributes = createEventScheduleAttribute?.map(
    (section) => ({
      ...section,
      value: section?.value?.map((field) => ({
        ...field,
        readOnly: eventId ? field.readOnly || !isEditMode : false,
      })),
    })
  );

  if (loaders?.createEventSchedule) {
    return (
      <Box
        sx={{
          height: "90vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        marginY="auto"
      >
        <CircularProgress color="inherit" />
      </Box>
    );
  }

  return (
    <Box px={eventId ? "auto" : 3}>
      <form onSubmit={handleCreateEventSchedule}>
        <Box>
          <Stack
            direction={{ sm: "row" }}
            justifyContent="space-between"
            alignItems="flex-start"
            pb={eventId ? 3 : "auto"}
          >
            {!eventId && (
              <Stack className={classes.heading} mb={{ sm: 3, xs: 1 }}>
                <VSNTypography variant="h5" component="h5">
                  Create Event
                </VSNTypography>
                <VSNTypography variant="body1" component="p" color="#3A3A40">
                  Set up and schedule the upcoming event in just a few steps.
                </VSNTypography>
              </Stack>
            )}

            {eventId && !isEditMode && (
              <VSNButton
                sx={{
                  flex: "none",
                  marginLeft: "auto",
                  width: { sm: "auto", xs: "100%" },
                  marginTop: 3,
                }}
                handleClick={() => setIsEditMode((prev) => !prev)}
              >
                Edit Event
              </VSNButton>
            )}
          </Stack>

          <Grid container spacing={3}>
            {formSectionAttributes?.map(
              ({ label, value, md, subTitle }, sectionIndex) => (
                <Grid item xs={12} md={md} key={sectionIndex}>
                  <Stack
                    sx={{
                      padding: { sm: 3, xs: 2 },
                      background: "#ffffff",
                      borderRadius: 2,
                      boxShadow: "0px 0px 14px 0px #0000001A",
                      height: "100%",
                    }}
                  >
                    <VSNTypography
                      sx={{ color: "#86650A", fontWeight: 700, fontSize: 14 }}
                    >
                      {upperCase(label)}
                    </VSNTypography>
                    <VSNTypography
                      sx={{ color: "#3A3A40", fontWeight: 400, fontSize: 16 }}
                    >
                      {subTitle}
                    </VSNTypography>
                    <Grid
                      container
                      rowSpacing={{ xs: 0, md: 2 }}
                      columnSpacing={4}
                      className={classes.formGrid}
                      pt={3}
                    >
                      {value?.map((props, index) => {
                        const {
                          isRequired,
                          label,
                          errorMessage,
                          name,
                          value,
                          getValBy,
                          md,
                          doNotShow,
                          control,
                          readOnly,
                          question,
                          ...attribute
                        } = props;

                        if (question) {
                          return (
                            <React.Fragment key={index}>
                              <Grid item xs={12} md={12} key={index}>
                                <VSNLabel required={isRequired} label={label} />
                                <Stack
                                  direction="row"
                                  flexWrap="wrap"
                                  justifyContent="space-between"
                                  gap={2}
                                >
                                  <Stack position="relative" mr={2}>
                                    {!readOnly && (isEditMode || !eventId) && (
                                      <Stack
                                        direction={{
                                          sm: "row",
                                          xs: "column",
                                        }}
                                        alignItems={{
                                          sm: "center",
                                          xs: "start",
                                        }}
                                        key={index}
                                      >
                                        <Stack
                                          alignItems="center"
                                          justifyContent="center"
                                          color="var(--primary)"
                                          className={`${classes.uploadWrapper}`}
                                          border={
                                            highlighted
                                              ? "2px dashed var(--primary)"
                                              : "1px solid #CBCBCF"
                                          }
                                          onDragEnter={onDragEnter}
                                          onDragLeave={onDragLeave}
                                        >
                                          <VSNTypography variant="h6">
                                            Drop CSV files here or
                                            <span>Click to upload</span>
                                          </VSNTypography>
                                          <ControlForm
                                            {...{
                                              ...attribute,
                                              elementId: index,
                                              onChange: handleChange,
                                              name,
                                              control,
                                              value: "",
                                              readOnly,
                                              // handleMobileChange,
                                            }}
                                            className={classes.inputUpload}
                                          />
                                        </Stack>
                                      </Stack>
                                    )}
                                    <Box
                                      sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                      }}
                                    >
                                      {formData?.csv_file && (
                                        <Box
                                          sx={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            padding: "4px 8px",
                                            marginTop: "4px",
                                            borderRadius: "4px",
                                            backgroundColor: "#E2ECFD",
                                            width: "100%",
                                            maxWidth: 265,
                                          }}
                                        >
                                          <VSNTypography
                                            className={classes.uploadText}
                                            sx={{
                                              whiteSpace: "nowrap",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                            }}
                                            title={formData?.csv_file?.name}
                                          >
                                            {formData?.csv_file?.name}
                                          </VSNTypography>

                                          <IconButton
                                            onClick={() => removeUploadedFile()}
                                            color="primary"
                                            aria-label="remove file"
                                            component="span"
                                          >
                                            <DeleteIcon />
                                          </IconButton>
                                        </Box>
                                      )}
                                    </Box>

                                    <VSNErrorMessage
                                      {...{
                                        formError: formErrors?.[name],
                                        errorMessage,
                                        className: classes.csvError,
                                      }}
                                    />

                                    {!readOnly && (
                                      <VSNTypography
                                        className={classes.downloadCsvButton}
                                        onClick={downloadTemplateFile}
                                      >
                                        Download CSV Template
                                      </VSNTypography>
                                    )}
                                  </Stack>

                                  <Stack
                                    direction={{ sm: "row" }}
                                    flexWrap="wrap"
                                    gap={2}
                                    width={{ sm: "auto", xs: "100%" }}
                                    className={classes.btnWrap}
                                  >
                                    {eventId && (
                                      <VSNButton
                                        handleClick={() => handleViewRoster()}
                                        className={
                                          classes.downloadEventRosterBtn
                                        }
                                        isLoading={loaders?.viewRosterList}
                                        variant="contained"
                                        sx={{ flex: { sm: "none", xs: 1 } }}
                                      >
                                        View Roster
                                      </VSNButton>
                                    )}
                                    {eventId && (
                                      <VSNButton
                                        handleClick={DownloadUploadedCSVFile}
                                        className={
                                          classes.downloadEventRosterBtn
                                        }
                                        isLoading={loaders?.downloadCSVFile}
                                        variant="outlined"
                                        sx={{ flex: { sm: "none", xs: 1 } }}
                                      >
                                        Download Roster
                                      </VSNButton>
                                    )}
                                  </Stack>
                                </Stack>
                              </Grid>
                            </React.Fragment>
                          );
                        }

                        return (
                          !doNotShow && (
                            <Grid
                              item
                              xs={12}
                              md={md}
                              key={index}
                              mb={{ xs: 2, md: 0 }}
                              display="flex"
                              flexDirection="column"
                            >
                              <VSNLabel required={isRequired} label={label} />
                              <ControlForm
                                {...{
                                  ...attribute,
                                  elementId: index,
                                  label,
                                  name,
                                  handleMobileChange,
                                  onChange: handleChange,
                                  handleDateChange,
                                  handleTimeChange,
                                  value:
                                    formData?.[name] ??
                                    (control === "select" ? 0 : ""),
                                  control,
                                  handleChangePhoto,
                                  handleSwitchChange,
                                  readOnly,
                                }}
                              />
                              <VSNErrorMessage
                                {...{
                                  formError: formErrors?.[name],
                                  errorMessage,
                                }}
                              />
                            </Grid>
                          )
                        );
                      })}
                    </Grid>
                  </Stack>
                </Grid>
              )
            )}
          </Grid>

          {(isEditMode || !eventId) && (
            <Stack
              direction="row"
              flexWrap="wrap"
              gap={2}
              className={classes.buttons}
            >
              <VSNButton
                variant="outlined"
                className={classes.createLinkButton}
                handleClick={() => {
                  if (eventId) {
                    handleCancleEditEvent();
                  } else {
                    navigate("/org-admin?fromTo=departments");
                  }
                }}
              >
                Cancel
              </VSNButton>
              <VSNButton
                isLoading={loaders?.createEventSchedule}
                className={classes.createLinkButton}
                type="submit"
                handleClick={handleCreateEventSchedule}
              >
                Save
              </VSNButton>
            </Stack>
          )}
        </Box>
      </form>

      {modelState?.viewRosterModal && (
        <VSNModel
          open={modelState?.viewRosterModal}
          onClose={() => {
            dispatch(toggleModelShow("viewRosterModal"));
          }}
          disableEnforceFocus
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          mobileDrawer
          // className={classes.inviteAdminModel}
        >
          <EventEmailPreviewModal
            title={eventScheduleInfo?.event_name ?? "Roster list"}
            subTitle="View all participants scheduled for this event along with their service level"
            data={viewRosterList}
            list
          />
        </VSNModel>
      )}

      {showDialog && (
        <VSNConfirmBox
          isOpen={showDialog}
          title="Are You Sure?"
          msg="Do you want to save your changes before continuing?"
          handleOk={onEditCreateClick}
          handleCancel={onHandleCancle}
          okBtnName="Save Changes"
          cancelBtnName="Cancel"
          className={classes.conformModel}
          isLoading={loaders?.createEventSchedule}
        />
      )}
    </Box>
  );
};

export default EventDetails;
